import styled from 'styled-components';
import colors from 'themes/Main';

import { LinkText } from '../NavBarLink/styles';

const { gradient, white } = colors;

export const Button = styled.button`
  position: relative;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px 15px;
  text-decoration: none;
  transition: all 0.3s;
  width: 100%;
  border: 0;
  outline: 0;

  &:hover {
    background: ${gradient};

    svg path {
      fill: ${white};
    }

    p {
      color: ${white};
    }
  }
`;

export const ButtonText = styled(LinkText)``;
